import {
    ACTION_END,
    ACTION_FOR_EACH,
    ACTION_TRIGGER_ACKNOWLEDGE,
    MODEL_ENTITY_APP,
    MODEL_ENTITY_RULE,
    RULE_EXPRESSION_EVALUATE,
    WORKFLOW_PATH_BEGIN,
    WORKFLOW_PATH_EMPTY,
    WORKFLOW_PATH_END,
    WORKFLOW_PATH_ERROR,
    WORKFLOW_PATH_FALSE,
    WORKFLOW_PATH_GROUP_ENTRY,
    WORKFLOW_PATH_GROUP_EXIT,
    WORKFLOW_PATH_SUCCESS,
    WORKFLOW_PATH_TRUE
} from '../../../models/workflow'
import _ from 'lodash'
import {WORKFLOW_ZUDELLO_LOG_ERROR_MODULE} from '../../../types/workflow/block'

export const appBlockPathConnectorModel = Object.freeze({
    success_path: {
        key: WORKFLOW_PATH_SUCCESS,
        label: 'Success path to',
        caption: 'Success',
        order: 1
    },
    error_path: {
        key: WORKFLOW_PATH_ERROR,
        label: 'Error path to',
        caption: 'Error',
        order: 2
    },
    empty_path: {
        key: WORKFLOW_PATH_EMPTY,
        label: 'Empty data path to',
        caption: 'Empty data',
        order: 3
    }
})

export const ruleBlockPathConnectorModel = Object.freeze({
    true_path: {
        key: WORKFLOW_PATH_TRUE,
        label: 'True path to',
        caption: 'Yes',
        order: 1
    },
    false_path: {
        key: WORKFLOW_PATH_FALSE,
        label: 'False path to',
        caption: 'No',
        order: 2
    },
    error_path: {
        key: WORKFLOW_PATH_ERROR,
        label: 'Error path to',
        caption: 'Error',
        order: 3
    }
})

export const loopBlockPathConnectorModel = Object.freeze({
    begin_path: {
        key: WORKFLOW_PATH_BEGIN,
        label: 'Begin path to',
        caption: 'Start',
        order: 1
    },
    end_path: {
        key: WORKFLOW_PATH_END,
        label: 'End path to',
        caption: 'End',
        order: 2
    }
})

// handled separately
export const blocksGroupPathConnectorModel = Object.freeze({
    entry_path: {
        key: WORKFLOW_PATH_GROUP_ENTRY,
        label: 'Entry path to',
        caption: 'Entry',
        order: 1
    },
    exit_path: {
        key: WORKFLOW_PATH_GROUP_EXIT,
        label: 'Exit path from',
        caption: 'Exit',
        order: 2
    }
})

export const getPathConnectorModelForBlockGroup = blockGroup => {
    // one case for now
    return _.sortBy(Object.values(blocksGroupPathConnectorModel), 'order')
}

export const getPathConnectorModelForBlock = block => {
    const {entity, key} = block.model
    let data
    if ([RULE_EXPRESSION_EVALUATE, ACTION_TRIGGER_ACKNOWLEDGE].includes(key)) {
        data = appBlockPathConnectorModel
    } else if (key === ACTION_FOR_EACH) {
        data = loopBlockPathConnectorModel
    } else if (entity === MODEL_ENTITY_RULE) {
        data = ruleBlockPathConnectorModel
    } else if (entity === MODEL_ENTITY_APP) {
        data = appBlockPathConnectorModel
    }
    if (data) {
        return _.sortBy(Object.values(data), 'order')
    }
    return []
}

export const pathConnectorCustomOptions = Object.freeze({
    log_error: {
        key: 'log_error',
        name: WORKFLOW_ZUDELLO_LOG_ERROR_MODULE
    },
    log_error_and_end: {
        key: 'log_error_and_end',
        name: `${WORKFLOW_ZUDELLO_LOG_ERROR_MODULE} and End`
    },
    end: {
        key: ACTION_END,
        name: 'End'
    }
})

export const pathConnectorCustomOptionsList = Object.freeze(Object.values(pathConnectorCustomOptions))
